import { render, staticRenderFns } from "./LocationServiceDemographicInfo.vue?vue&type=template&id=010ea683&scoped=true"
import script from "./LocationServiceDemographicInfo.vue?vue&type=script&lang=js"
export * from "./LocationServiceDemographicInfo.vue?vue&type=script&lang=js"
import style0 from "./LocationServiceDemographicInfo.vue?vue&type=style&index=0&id=010ea683&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ea683",
  null
  
)

export default component.exports